import StartIcon from "@mui/icons-material/Start";
import { Button } from "@mui/material";
import { useNavigate } from "react-router-dom";

export default function SpecialButton({
  buttontext,
  routingPath,
  id,
  disabled = false,
}) {
  const navigate = useNavigate();

  return (
    <Button
      disabled={disabled}
      sx={{
        borderRadius: 0,
      }}
      endIcon={<StartIcon />}
      onClick={() => navigate("/" + routingPath + "/" + id)}
    >
      {buttontext}
    </Button>
  );
}
